<div class="foreword">
    <p>
        {{'ci.reports.foreword1' | translate}}
    </p>
    <p>
        {{'ci.reports.foreword2' | translate}}
    </p>
</div>
